<div class="dashboard-container">
  <navbar></navbar>
  <sidenav></sidenav>
</div>
